import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// selectors/actions
import { getChartlessEventsFacetList } from 'selectors/seatingchart/seatingListSelector';
import { addNewChart, createEventAndChart } from 'actions/SeatingChartActions';
// constants
import EVENT_TYPES from 'components/manage/events/util/EventTypes';
// components
import Loader from 'components/common/ui/Loader';
import CreateEventFrom from '../ChartCreator/CreateEventForm/CreateEventForm';
import SingleEventForm from '../ChartCreator/SingleEventForm/SingleEventForm';
import SelectEventForm from '../ChartCreator/SelectEventForm/SelectEventForm';

const AddChart = ({
  chartlessFacetList,
  createChart,
  createEventWithChart,
  isFetchingCharts,
  isFetchingEvents,
}) => {
  // show loader
  const previousBusyVal = useRef();
  useEffect(() => {
    previousBusyVal.current = isFetchingCharts || isFetchingEvents;
  });
  const prevBusy = previousBusyVal.current;
  if (prevBusy || isFetchingCharts || isFetchingEvents)
    return (
      <div className="seating-create-modal loading">
        <Loader />
      </div>
    );

  // show form:
  const numChartless = chartlessFacetList.length;
  if (numChartless === 0) {
    return <CreateEventFrom eventTypes={EVENT_TYPES} createEventWithChart={createEventWithChart} />;
  }
  // 1 chartless event:
  if (numChartless === 1) {
    const eventFacet = chartlessFacetList[0];
    const { event_id: id, name } = eventFacet.value;
    return <SingleEventForm event={{ id, name }} createChart={createChart} />;
  }
  // +1 chartless event:
  return <SelectEventForm eventFacetList={chartlessFacetList} createChart={createChart} />;
};

AddChart.propTypes = {
  chartlessFacetList: PropTypes.arrayOf(PropTypes.shape({})),
  createChart: PropTypes.func,
  createEventWithChart: PropTypes.func,
  isFetchingCharts: PropTypes.bool,
  isFetchingEvents: PropTypes.bool,
};

const mapStateToProps = state => ({
  chartlessFacetList: getChartlessEventsFacetList(state),
  orderedEventIds: state.events.events.orderedIds,
  isFetchingEvents: state.events.events.busy,
  isFetchingCharts: state.seatingChart.busy,
});
const mapDispatchTopProps = dispatch => ({
  createChart: (event, tables) => dispatch(addNewChart(event, tables)),
  createEventWithChart: (event, tables) => dispatch(createEventAndChart(event, tables)),
});

export default connect(mapStateToProps, mapDispatchTopProps)(AddChart);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Modals/AddChart.jsx